import * as z from 'zod/v4'

import {type CommandValueFor, createNamespacedActionCreator} from '../defineAction'

const createAction = createNamespacedActionCreator('import')

export const importActions = [createAction('open', z.strictObject({noteId: z.string().optional()}).optional())] as const

export const importDescriptions = {
  import_open:
    'Open the file picker to import a file. Imports into the current note if one is open, otherwise creates a new note.'
} satisfies Record<CommandValueFor<typeof importActions>, string>
